/* From snippets/product-sticky-add-to-cart.liquid. Loaded only where that file renders; the guard stops a second copy running
   when the section is rendered twice or swapped in by the bundle switcher. */
(function () {
  if (window.__cancha_product_sticky_add_to_cart_loaded) return;
  window.__cancha_product_sticky_add_to_cart_loaded = true;

  (function () {
    var THRESHOLD = 6;
    var lastY = window.scrollY;
    var ticking = false;
    // While a variant change is settling, the gallery filtering reflows the page and shifts
    // the scroll position; we hold the expand/collapse state so that reflow isn't mistaken for
    // a deliberate scroll (which would otherwise collapse the bar and hide the updated thumbnail).
    var holdStateUntil = 0;

    function applyDirection() {
      ticking = false;
      var y = window.scrollY;
      if (Date.now() < holdStateUntil) { lastY = y; return; }
      if (Math.abs(y - lastY) < THRESHOLD) return;
      var collapse = y > lastY && y > 0;
      var bars = document.querySelectorAll('product-sticky-add-to-cart.sticky-atc');
      for (var i = 0; i < bars.length; i++) {
        bars[i].toggleAttribute('data-collapsed', collapse);
        if (collapse) {
          var openSelector = bars[i].querySelector('[data-sticky-variant-selector][data-options-open]');
          if (openSelector) closeOptions(openSelector);
        }
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(applyDirection);
        ticking = true;
      }
    }, { passive: true });

    // When the variant changes, the product gallery calls scrollIntoView() to bring the
    // new variant's image into view. From the sticky bar (scrolled far down the page) that
    // yanks the viewport. We briefly no-op scrollIntoView so the user stays put — the sticky
    // thumbnail updating is the visual feedback. Restored immediately afterwards.
    var scrollIntoViewSuppressed = false;
    function suppressGalleryAutoScroll() {
      if (scrollIntoViewSuppressed) return;
      var proto = Element.prototype;
      var original = proto.scrollIntoView;
      proto.scrollIntoView = function () {};
      scrollIntoViewSuppressed = true;
      window.setTimeout(function () {
        proto.scrollIntoView = original;
        scrollIntoViewSuppressed = false;
      }, 1200);
    }

    // Mirror a sticky swatch selection onto the main product form's hidden radio,
    // then let the existing <variant-picker> delegate handle fetch + rerender.
    function escapeForSelector(value) {
      return (window.CSS && CSS.escape) ? CSS.escape(value) : value;
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.name || input.name.indexOf('sticky-') !== 0) return;
      if (!input.hasAttribute('data-option-position')) return;

      var bar = input.closest('product-sticky-add-to-cart');
      if (!bar) return;

      var variantSelector = input.closest('[data-sticky-variant-selector]');
      if (variantSelector) closeOptions(variantSelector);

      var mainFormId = bar.getAttribute('main-product-form');
      if (!mainFormId) return;

      var mainForm = document.forms[mainFormId];
      var position = input.getAttribute('data-option-position');
      var mainName = mainFormId + '-option' + position;
      var selector = 'input[name="' + escapeForSelector(mainName) + '"][value="' + escapeForSelector(input.value) + '"]';

      var mainInput = document.querySelector(selector);
      if (mainInput && !mainInput.checked) {
        suppressGalleryAutoScroll();
        // Keep the bar expanded so the updated thumbnail is visible, and ignore the reflow-induced
        // scroll shift for a moment so it isn't misread as a scroll-down (which would re-collapse it).
        bar.removeAttribute('data-collapsed');
        holdStateUntil = Date.now() + 1200;
        mainInput.checked = true;
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    function closeOptions(selector) {
      var toggle = selector.querySelector('[data-sticky-option-toggle]');
      selector.removeAttribute('data-options-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      var toggle = event.target.closest('[data-sticky-option-toggle]');

      if (toggle) {
        var selector = toggle.closest('[data-sticky-variant-selector]');
        var willOpen = !selector.hasAttribute('data-options-open');

        document.querySelectorAll('[data-sticky-variant-selector][data-options-open]').forEach(function (openSelector) {
          if (openSelector !== selector) closeOptions(openSelector);
        });

        selector.toggleAttribute('data-options-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

        return;
      }

      document.querySelectorAll('[data-sticky-variant-selector][data-options-open]').forEach(function (selector) {
        if (!selector.contains(event.target)) closeOptions(selector);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-sticky-variant-selector][data-options-open]').forEach(function (selector) {
        var toggle = selector.querySelector('[data-sticky-option-toggle]');
        closeOptions(selector);
        if (toggle) toggle.focus();
      });
    });
  })();
})();
